import React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  className?: ClassName;
  checkmarkColor?: FillColor;
  circleColor?: FillColor;
}

const defaultProps = {
  className: '',
  checkmarkColor: '#185941',
  circleColor: '#97E0CE',
};

const CheckmarkCircleIcon = ({
  className,
  checkmarkColor,
  circleColor,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-labelledby="checkmarkCircleIcon"
  >
    <title id="checkmarkCircleIcon">Checkmark Circle</title>
    <circle cx="14" cy="14" r="14" fill={circleColor} fillOpacity="0.4" />
    <path
      d="M8.70711 13.2929C8.31658 12.9024 7.68342 12.9024 7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071L11.2929 18.7071C11.6834 19.0976 12.3166 19.0976 12.7071 18.7071L20.7071 10.7071C21.0976 10.3166 21.0976 9.68342 20.7071 9.29289C20.3166 8.90237 19.6834 8.90237 19.2929 9.29289L12 16.5858L8.70711 13.2929Z"
      fill={checkmarkColor}
    />
  </svg>
);

CheckmarkCircleIcon.defaultProps = defaultProps;

export { CheckmarkCircleIcon };
